import { SET_LISTINGS_META_DATA } from '../../actions/actionTypes'

export const initialMetaState = {
  resultCode: 0,
  processorID: '', // Not required for FE use
  clientSessionId: '',
  searchKey: '',
  searchId: '',
  requestId: '',
  hasExpressDeal: false,
  hasUpsellOptions: false,
  hasClosedUserGroupDeals: false,
  cheapestFlightNonStop: '',
  minimumRetailPrice: 0,
  nonStopPrice: 0,
  tripType: '',
  lowerBound: 0,
  upperBound: 30,
  totalItineraries: 0,
  totalFilteredItineraries: 0
}

export function listingsMetaData(state = initialMetaState, action) {
  switch (action.type) {
    case SET_LISTINGS_META_DATA:
      return Object.assign({}, state, {
        ...action.meta
      })
    default:
      return state
  }
}
